const timeline = [
  {
    title: "Launch",
    items: ["Ideation & Core Infrastructure", "OZORA Data Vault", "Research & Architecture Design", "Smart Contract & Token Framework"]
  },
  {
    title: "Development P1",
    items: ["OZORA Machine Learning Engine", "OZORA Nodes", "Expanded Data Vault", "OZORA Personal Platform (Alpha)"]
  },
  {
    title: "Development P2",
    items: ["OZORA Business Platform", "Advanced Data Vault v2", "Machine Learning Engine Upgrade", "OZORA Stream Network Testnet"]
  },
  {
    title: "Development P4",
    items: ["OZORA Personal Platform (Public)", "OZORA Business Platform (Enterprise)", "Stream Network Mainnet", "OZORA Predictive AI Agents (PAA)"]
  }
];

export default function TimelineSection() {
  return (
    <section className="px-6 py-20 max-w-5xl mx-auto text-white">

      <h2 className="text-[var(--accent-mint)] text-sm flex items-center gap-2">
        <img src="/steps/star-icon.svg" className="w-3" />
        Roadmap
      </h2>

      <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">
        Our Timeline on Development Goals. 
      </h2>

      <h2 className="text-xl flex items-center mt-6">
        The roadmap shows our systematic approach to building OZORA AI at scale. A continuous user feedback loop drives faster innovation, better tools, and real-world utility.
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        {timeline.map(block => (
          <div
            key={block.title}
            className="glass-panel border border-white/10 p-6 rounded-2xl"
          >
            <h3 className="text-xl font-bold text-[var(--accent-mint)]">{block.title}</h3>
            <p className="text-[#b9e5dd] text-sm">{block.note}</p>

            <ul className="mt-4 text-sm text-white space-y-1">
              {block.items.map(i => (
                <li key={i}>• {i}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}